import { render, staticRenderFns } from "./SocialShare_component.vue?vue&type=template&id=d8b5f63e"
import script from "./SocialShare_component.vue?vue&type=script&lang=js"
export * from "./SocialShare_component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports